enum API {
	GRADUATES = '/api/graduates',
	GRADUATES_BY_ID = '/api/graduates/',
	GRADUATES_UPLOAD = '/api/graduates/upload',
	GRADUATES_TEMPLATE = '/api/graduates/download/template',
	GRADUATES_DOCUMENTS = '/api/graduates/files',
	GRADUATES_DOCUMENTS_BY_ID = '/api/graduates/files/'
}

export default API;
